import { Box, Loader } from '@acast/decibel';
import React from 'react';

const PendingPage = () => (
  <Box height={85} alignItems="center" justifyContent="center" data-test-id="PendingPage">
    <Loader />
  </Box>
);

export default PendingPage;
